var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40005 6.66667V13.3333H17.6001V6.66667C17.6001 6.66667 15.3756 5.73333 12.0001 5.73333C8.62446 5.73333 6.40005 6.66667 6.40005 6.66667ZM14.8001 16C14.8001 16.736 15.4273 17.3333 16.2001 17.3333C16.9729 17.3333 17.6001 16.736 17.6001 16C17.6001 15.264 16.9729 14.6667 16.2001 14.6667C15.4273 14.6667 14.8001 15.264 14.8001 16ZM6.40005 16C6.40005 16.736 7.02725 17.3333 7.80005 17.3333C8.57285 17.3333 9.20005 16.736 9.20005 16C9.20005 15.264 8.57285 14.6667 7.80005 14.6667C7.02725 14.6667 6.40005 15.264 6.40005 16ZM12.0001 4C16.2001 4 19.0001 5.33333 19.0001 5.33333V6.50002L20.2378 7.32521C20.3981 7.43202 20.4827 7.62133 20.4555 7.81194L20.0371 10.7407C20.0139 10.9031 19.9125 11.0438 19.7657 11.1172L19.0001 11.5V18.6667C19.0001 19.403 18.3733 20 17.6001 20H16.2001L15.5001 18.6667H8.50005L7.80005 20H6.40005C5.62685 20 5.00005 19.403 5.00005 18.6667V5.33333C5.00005 5.33333 7.80005 4 12.0001 4ZM3.76221 7.32521L5.00003 6.5V11.5L4.23434 11.1172C4.08759 11.0438 3.98618 10.9031 3.96298 10.7407L3.54459 7.81194C3.51736 7.62133 3.602 7.43202 3.76221 7.32521Z",
    fill: "#1A73F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.e4bb56615107c5e82851e6ef28f58617.svg";
export { ForwardRef as ReactComponent };